import { gql } from "@apollo/client";

export const googleMerchantFeedPushMutation = gql`
  mutation GoogleMerchantFeedPush($input: GoogleMerchantFeedPushInput!) {
    googleMerchantFeedPush(input: $input) {
      total
      succeeded
      failed
      errorsSample
      feedUrl
      googleMerchantErrors {
        field
        message
        code
      }
    }
  }
`;
